import { render, staticRenderFns } from "./ListRolePage.vue?vue&type=template&id=79c25c86"
import script from "./ListRolePage.vue?vue&type=script&lang=js"
export * from "./ListRolePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports